module.exports = __webpack_public_path__ + "img/discount_announce.ab41b7c7.svg";